module.exports = __webpack_public_path__ + "img/insurance-logo-3.9b0258e5.png";